import { NewsContentType } from '@/types/enum';

export default {
  id: '20220601', //  模块 id
  title: '叮咚买菜打造儿童膳食一站式解决方案', // 标题
  origin: '2022-06-01 11:20 来源：北京青年报', // 新闻来源
  editor: '责任编辑：樊宏伟', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '随着儿童科学膳食成为大众关注的焦点，北京青年报记者6月1日了解到，叮咚买菜“宝妈严选”儿童食品板块，再度升级“儿童食品入选标准2.0”，走到农产品源头，实现“从种子到餐桌”的完整可追溯供应链，并与营养师合作，为家长提供儿童膳食产品+内容+服务的一站式解决方案。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '由于目前市场上普遍没有设置专门的“儿童食品”分类，对家长们来说，分辨符合儿童饮食标准的食品往往有不低的门槛。在叮咚买菜近日对家长的“儿童食品消费问卷”中，仅54%的家长表示在购买儿童食品时，会查看配料表和营养成分表。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '叮咚买菜食品研究院负责人申强表示，并不是商品名中含有“儿童”的就一定适合儿童，最重要还是看配料表。我们“宝妈严选”在业内率先将配料表、营养成分表放在商品页首页，并且配上注册营养师的解说，帮助家长辨别。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '同时，叮咚买菜所有儿童食品严格按照“儿童食品入选标准2.0”，禁止配料中含有反式脂肪酸和转基因成分；低糖低盐，糖的含量原则上不超过5%，钠含量尽可能低于450mg等，杜绝不符合儿童营养需求的食品。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '各地家长在儿童食品类型的选择倾向也有区别。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '比如，上海和江苏的家长更倾向于早餐类，比如米面制品、牛奶、鸡蛋品类，其中销量最多的儿童食品包括“良芯匠人”迷你小肉肉花卷、崇明原粮乳鸽、渔夫保萝翡翠大虾仁等',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '早餐营养对学龄儿童尤为重要。申强介绍，叮咚买菜最开始自主研发、生产的就是早餐，比如最受家长欢迎的“良芯匠人”迷你小肉肉花卷，就来自其自建的面食工厂，通过基地直采原材料，肉馅中的猪肉来自哪个养殖基地，过程和标准全程可控，真正实现儿童食品的全程透明可溯源。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '广东地区的家长在食材类型的选择上，更青睐高蛋白生鲜食材，比如供港壹号有机纯牛奶、唐顺兴冷鲜整只五两鸽、渔夫保萝三文鱼柳、可生食鲜鸡蛋等等。北京地区的家长在食材类型的选择上，更青睐有机食品，销量排名前五的儿童食品是：鸿湘斋甄选无抗安全蛋、有机鲜牛奶、有机韭菜、有机洋葱、BAP全球认证鲜活鲈鱼。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      isIndent: true,
      text:
        '申强介绍，“宝妈严选”的生鲜食材的基地全部来自于有机基地或有国际认证资质的基地，由订单农业的专家组进行严格把关，真正实现“从种子到餐桌的完整供应链”。',
    },
  ],
};
